<!-- <button kendoButton (click)="this.diffXML()">Compare</button> -->
@if (this.isEditing) {
    <kendo-dialog title="Diff" width="1500px" (close)="this.isEditing = false">
        <div class="header">
            <div>{{this.leftLabel}}</div>
            <div>{{this.rightLabel}}</div>
        </div>
        <div class="monaco">
            <ngx-monaco-diff-editor style="height: 100%" [options]="options" [originalModel]="originalModel" [modifiedModel]="modifiedModel"></ngx-monaco-diff-editor>
        </div>

        @if (this.jsBridgeService.isDev()) {
            <button kendoButton (click)="this.toggleXML()" [togglable]="true" themeColor="primary">XML</button>
        }
        
        <kendo-dialog-actions>
            <button kendoButton (click)="this.isEditing = false">Close</button>
        </kendo-dialog-actions>
    </kendo-dialog>
    
    
}